<template>
    <div>
		<el-card class="box-card" v-loading="dataLoading">
		    <div slot="header" class="clearfix">
		        <span>
		            <span class="el-icon-data-line"></span> 拉新用户 <small><span class="color-danger">该页面统计的是演出上线（通过审核）后到演出结束（以最晚结束的场次结束时间为准）之间，新注册的用户，当前拉新总用户数：{{data.totalUser}}</span></small>
		        </span>
		    </div>
			<div class="content"  v-if="data && data.list && data.list.length >0 ">
			   <div id="chartContainerNewuser"></div>
			</div>
		</el-card>
    </div>
</template>

<script>
import { Chart } from '@antv/g2';
export default {
    props: {
        activityId: {
            type: [Number, String],
            default: () => null
        },
		// data:{
		// 	type: Object,
		// 	default: null,
		// },
		ticketNameData:{
			type: Array,
			default: () => {
				return [];
			}
		}
		
    },
    components: {},
    data() {
        return {
            dataLoading: false,			
			data:{},
			chart:null,
        }
    }, 
	mounted() {	  
		this.drawCharts()		
	},
    methods: {
		drawCharts(){
			this.dataLoading = true
			
			this.$request({
			    url: "/activity/statistics/newUser",
			    params: { id: parseInt(this.activityId) },
			    method: "post",
			})
			    .then((res) => {
			        const { state, msg, result } = res.data;
			        if (state == 1) {
						this.data = result
			            if( this.data && this.data.list.length > 0 ){
							this.dataLoading = false
							this.$nextTick(() => {
								this.drawChart1();
							})
						}
			        } else {
			            this.$message.error(msg || "获取信息失败,请重试");
			        }
			    })
			    .catch(() => {
			        this.$message.error("获取信息失败,请重试");
			    })
			    .finally(() => {
			        this.dataLoading = false;
			    });
		},
		drawChart1(){
		    if( this.chart ) this.chart.destroy();
		    let _data = this.data.list
		    _data.map( v => {
		        v.num = parseFloat(v.num);
		    })
		    this.chart = new Chart({
		        container: 'chartContainerNewuser',
		        autoFit: true,
		        height: 250,
		    });
		    this.chart.data(_data);
		    this.chart.interaction('active-region');    
		
		    this.chart.tooltip({
		        showTitle: false,
		        showMarkers: false,
		    });
		    this.chart
		        .interval()
		        .position('name*num')
		        .size(30)
		        .tooltip('name*num', (name, num) => {
		            
		            return {
		                name: name,
		                value: num,
		            };
		        });
		    this.chart.render();
			
		},
	   
    }
}
</script>